var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "react"], function (require, exports, react_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Widget = void 0;
    react_1 = __importDefault(react_1);
    function Widget(props) {
        return (react_1.default.createElement("span", { className: "echomd-widget", onClick: function (event) { return event.preventDefault(); } }, props.children));
    }
    exports.Widget = Widget;
});
